import { refine } from 'superstruct';

/**
 * Validation that's dependent on defined 'fields' to pass 'type's validation
 * @param struct The superstruct type if all conditions are met
 * @param fields Array of keys that 'type' depends on to be defined to pass validation
 * @param amountRequired Amount of fields needed to pass validation, default: length of fields
 * @param validator Test against 'type's value to consider validating, default: true
 * @param message Custom validation message. Can be i18next key
 * @param checkIfEmpty Check if fields are empty instead of defined
 */
export function requireFields(struct, fields, options) {
  return refine(struct, '', (value, ctx) => {
    const {
      amountRequired = fields.length,
      validator = () => true,
      message = 'validations:Required Fields',
      checkIfEmpty = false
    } = options;

    // We need to be on the same level as this values context so we can
    // access the fields around it. Context levels change based on how
    // deeply nested this struct is in other structs
    const contextValues = ctx.branch.at(-2);
    const fieldValues = fields.map(key => {
      if (Array.isArray(contextValues[key])) {
        return checkIfEmpty ? contextValues[key].length === 0 : contextValues[key].length !== 0;
      }
      return checkIfEmpty ? !contextValues[key] : !!contextValues[key];
    });
    if (validator(value) && fieldValues.reduce((a, b) => +a + +b, 0) < amountRequired) {
      return {
        message
      };
    }
    return true;
  });
}